import Box from '@mui/material/Box';
import muiStyled from '@mui/material/styles/styled';
import styled from 'styled-components';

const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  left: 18px;
  width: 20px;
  height: 40px;
`;

const Arrow = muiStyled(Box)(({theme}) => ({
  width: 20,
  height: 20,
  backgroundColor: theme.palette.primary.main,
  borderRadius: 4,
  transform: 'rotate(45deg)',
  position: 'absolute',
  top: 10,
  left: -10
}));

// eslint-disable-next-line react/prop-types
const MorePopperArrow = ({style}) => (
  <ArrowContainer data-testid="MorePopperArrow" style={style}>
    <Arrow />
  </ArrowContainer>
);

export default MorePopperArrow;
